// import 'lazysizes/plugins/respimg/ls.respimg';
// import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/video-embed/ls.video-embed';
import 'lazysizes';
import 'alpinejs';
// import './vue/index';

// import { mount, axios } from './utils';
// mount('PostList', 'partial');

import AOS from 'aos';
AOS.init({
    once: true
});

/**
 * Components
 */
import './components/carousel';
import './components/cardReveal';
import './components/form';
import './components/header';
import './components/mobileNavigation';
import './components/navigation';
import './components/revealTransition';
import './components/wysiwygButton';
import './components/sticky';
import './components/toggle';
import './components/video';

/**
 * Vue
 */
import './vue/news/index';
